import { useQuery } from '@tanstack/react-query';
import { customerService } from '../../services/api';
import { retryOnServerError } from '../dashboard/queryOptions';

/**
 * Fetches a single campaign (GET /conversations/campaigns/{uuid}/), shared by
 * the dashboard and mobile detail pages.
 *
 * Gated by conversation.campaign.view: a 403 is an expected outcome, rendered
 * by the caller and never retried.
 */
export const useCampaignQuery = (uuid) =>
  useQuery({
    queryKey: ['campaign', uuid],
    queryFn: () => customerService.getCampaign(uuid).then((res) => res.data),
    enabled: !!uuid,
    staleTime: 30_000,
    retry: retryOnServerError,
  });
